'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Search$() {
}
export { $c_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Search$ as $c_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Search$ };
$p = $c_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Search$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Search$;
/** @constructor */
function $h_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Search$() {
}
export { $h_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Search$ as $h_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Search$ };
$h_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Search$.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.m = (function() {
  return (-1822469688);
});
$p.b = (function() {
  return "Search";
});
$p.n = (function() {
  return 0;
});
$p.o = (function() {
  return "Search";
});
$p.g = (function(n) {
  throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__T__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.y = (function(p) {
  return this;
});
var $d_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Search$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Search$, "be.doeraene.webcomponents.ui5.configkeys.InputType$Search$", ({
  gy: 1,
  b0: 1,
  b: 1,
  c: 1,
  a: 1,
  e: 1,
  g: 1,
  k: 1
}));
export { $d_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Search$ as $d_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Search$ };
var $n_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Search$;
function $m_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Search$() {
  if ((!$n_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Search$)) {
    $n_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Search$ = new $c_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Search$();
  }
  return $n_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Search$;
}
export { $m_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Search$ as $m_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Search$ };
